module.exports = __webpack_public_path__ + "static/img/strona_024.011aa3db.jpg";